import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Label } from "@air/primitive-label";
import React, { useCallback } from "react";
import { ResizableEditableTextInput } from "~/components/ResizableEditableTextInput";
import { customFieldIconMap } from "~/constants/customFieldIconMap";
export const BoardCollectionCustomFieldPlainText = (param)=>{
    let { disabled = false, field, required, onTextChange, size = "medium" } = param;
    const Icon = customFieldIconMap[field.type.title];
    const handleSubmit = useCallback((newValue)=>{
        if (newValue === field.plainTextValue) return;
        onTextChange(newValue);
    }, [
        field.plainTextValue,
        onTextChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col gap-1",
        children: [
            /*#__PURE__*/ _jsxs(Label, {
                className: "flex items-center font-semibold",
                htmlFor: field.id,
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "mr-1 flex size-4 text-grey-9"
                    }),
                    field.name,
                    required ? "*" : ""
                ]
            }),
            /*#__PURE__*/ _jsx(ResizableEditableTextInput, {
                label: "Field value",
                placeholder: "None",
                defaultValue: field.plainTextValue,
                onSubmit: handleSubmit,
                appearance: "outline",
                disabled: disabled,
                size: size
            })
        ]
    });
};
